import React, {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import '../../css/Home.css';
import logo from "../../assets/ensoll-bg.png";
import {useNavigate, useParams} from "react-router-dom";
import {jwtDecode} from "jwt-decode";
import {userResetPassword} from "../../api/user";

const ResetPassword = () => {

    const [values, setValues] = useState({
        newPassword: '',
        // confirmPass: ''
    });
    const [email, setEmail] = useState();

    const {token} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (token) {
            // Decode the token and set email
            const decoded = jwtDecode(token);
            setEmail(decoded.email);
            setValues({...values, resetPasswordLink: token});
        }
    }, [token]);

    const handleChange = name => event => {
        setValues({...values, [name]: event.target.value});
    };

    const validate = () => {
        // Αν θέλετε να ενεργοποιήσετε την επιβεβαίωση κωδικού, ξεχ σχόλια τον κώδικα παρακάτω:
        if (!values.newPassword || !values.confirmPass) {
            toast.error('Οι κωδικοί πρόσβασης είναι υποχρεωτικοί');
            return false;
        }
        if (values.newPassword !== values.confirmPass) {
            toast.error('Οι κωδικοί πρόσβασης δεν ταιριάζουν');
            return false;
        }
        return true;
    };

    const clickReset = event => {
        if (validate()) {
            userResetPassword(values)
                .then((res) => {
                    navigate('/signin');
                    toast.success(`Επιτυχής Επαναφορά Κωδικού Πρόσβασης`);
                })
                .catch((err) => {
                    toast.error(err.response.data.error);
                });
        }
    };

    return (
        <div>
            <section className="forms-section">
                <div className="forms">
                    <div className="form-wrapper is-active">
                        <button type="button" className="switcher switcher-login"
                                style={{cursor: "auto", transform: 'translate(30%, -20px)'}}>
                            Επαναφορά Κωδικού
                            <span className="underline"></span>
                        </button>
                        <form className="form"
                              style={{backgroundColor: "#fff", transform: 'translate(10%, -20px)', minWidth: '500px'}}>
                            <fieldset>
                                <img alt="logo"
                                     style={{
                                         maxWidth: "250px",
                                         height: "auto",
                                         margin: 'auto',
                                         padding: "20px",
                                         display: 'flex'
                                     }}
                                     src={logo}
                                />
                                <div className="input-block">
                                    <label style={{color: '#4a5568', fontWeight: 'bold'}}>Email</label>
                                    <input id="email" disabled value={email} style={{
                                        backgroundColor: '#e3e6e8'
                                    }}
                                           type="email" required/>
                                </div>
                                <div className="input-block">
                                    <label style={{color: '#4a5568', fontWeight: 'bold'}}>Νέος Κωδικός</label>
                                    <input id="newPassword" onChange={handleChange('newPassword')}
                                           value={values.newPassword}
                                           type="password"
                                           required/>
                                </div>
                                <div className="input-block">
                                    <label style={{color: '#4a5568', fontWeight: 'bold'}}>Επιβεβαίωση Νέου Κωδικού</label>
                                    <input id="ConfirmPassword" onChange={handleChange('confirmPass')}
                                           value={values.confirmPass} type="password"
                                           required/>
                                </div>
                            </fieldset>

                            <button type="button" style={{width: '200px'}} onClick={clickReset}
                                    className="btn-login">Επαναφορά Κωδικού
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ResetPassword;
